
import { FeatureCollection } from './../../../typescript/MapShapes';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Button from '../../../core/components/Generics/Button.vue';
import SimpleMap from '../../../core/components/Map/SimpleMap.vue';


@Component({
  components: {
    Button,
    SimpleMap
    
  }
})
export default class MapPolygons extends Vue {
  @Prop({default: null}) geojsonData: FeatureCollection
  @Prop({default(){return []}}) selectedItems: Array<object>
  @Prop({default: false}) visible: boolean


  @Emit()
  closeModal() {}
  
  @Emit()
  onSelectedRanchs(selectedPolygons) {}

  
}
